import React, { Component } from 'react';
import './App.css';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { withSnackbar } from 'notistack';
import qs from 'qs';
import FormGroup from '@material-ui/core/FormGroup';
import axios from 'axios';
import ModalPopup from './ModalPopup';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import ModalPopupLRG from './ModalPopupLRG';
import { urlConfig } from './config';

const styles = theme => ({
  container: {
    position: 'relative',
  },
});

class HighResGeneration extends Component {
  constructor(props) {
    super(props);
    let parsed = qs.parse(this.props.location.search);

    let cid = '';
    let path = '';

    if (parsed['cid']) cid = parsed['cid'];
    if (parsed['?path']) path = parsed['?path'];

    this.state = {
      cid,
      path,
      responseData: null,
      isloading: false,
      isError: false,
      show: false,
    };
  }

  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  highResGeneration = async (event) => {
    event.preventDefault();
    this.setState({
      isloading: true,
      isError: false,
      show: false,
      responseData: null,
    });

    const { cid, path } = this.state;

    // Clean and parse CIDs into array
    const cleanedCIDs = cid
      .split(/[\n,]+/)
      .map(c => c.trim())
      .filter(c => c.length > 0);

    // Prepare cids as comma-separated string
    const cidsParam = cleanedCIDs.join(',');

    try {
      const { data } = await axios.post(
        `${urlConfig.cmsURL}/videos/download`,
        null, // no request body
        {
          params: {
            cids: cidsParam,
            serverPath: path,
          },
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      this.setState({
        responseData: data,
        isloading: false,
        cid: '',
        path: '',
        isError: false,
      });
    } catch (error) {
      console.error('API error:', error);
      this.setState({
        isloading: false,
        isError: true,
      });
    }
  };

  render() {
    const { responseData, isloading, path, cid, isError, show } = this.state;
    const { classes } = this.props;

    const Loader = () => (
      <div className="loader-wrapper">
        <div className="loader"></div>
        <p>Processing...</p>
      </div>
    );

    const onClickPopupClose = () => {
      this.setState({ show: false });
    };

    const onClickPopupOpen = (e) => {
      e.preventDefault();
      this.setState({ show: true });
    };

    return (
      <React.Fragment>
        <Paper>
          <Grid spacing={0} container direction="row" justify="flex-start" alignItems="center">
            <Grid item xs={1}></Grid>
            <Grid item xs={10}>
              <form onSubmit={onClickPopupOpen}>
                <FormGroup row>
                  <Grid spacing={2} container direction="row" justify="flex-start" alignItems="center">
                    <Grid item xs={8}>
                      <TextField
                        id="outlined-path"
                        label="Server Path"
                        onChange={this.handleChange}
                        margin="normal"
                        fullWidth
                        multiline
                        rows={2}
                        name="path"
                        value={path}
                        variant="outlined"
                        required
                      />
                    </Grid>

                    <Grid item xs={2}>
                      <TextField
                        id="outlined-cid"
                        label="CID(s)"
                        onChange={this.handleChange}
                        margin="normal"
                        variant="outlined"
                        fullWidth
                        multiline
                        rows={3}
                        value={cid}
                        required
                        name="cid"
                        helperText="Comma separated"
                      />
                    </Grid>

                    <Grid item xs={2}>
                      <Button
                        disabled={isloading}
                        variant="contained"
                        color="primary"
                        type="submit"
                        size="large"
                        className={classes.button}
                      >
                        Submit
                      </Button>
                    </Grid>

                    {show && <ModalPopupLRG show={show} close={onClickPopupClose} submit={this.highResGeneration} />}
                  </Grid>
                </FormGroup>
              </form>

              <ModalPopup />

              <style jsx>{`
                .loader {
                  border: 8px solid #f3f3f3;
                  border-top: 8px solid #ffbf00;
                  border-radius: 50%;
                  width: 50px;
                  height: 50px;
                  animation: spin 2s linear infinite;
                }
                .loader-wrapper {
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  flex-direction: column;
                  margin-top: 1rem;
                }
                @keyframes spin {
                  0% {
                    transform: rotate(0deg);
                  }
                  100% {
                    transform: rotate(360deg);
                  }
                }
              `}</style>

              {isloading ? (
                <Loader />
              ) : (
                <>
                  {isError && (
                    <p style={{ color: 'red', fontSize: '1rem' }}>
                      Something went wrong. Please try again.
                    </p>
                  )}

                  {responseData && (
                    <>
                      {responseData.startedCids && responseData.startedCids.length > 0 && (
                        <p style={{ fontSize: '1rem', fontWeight: 'bold', color: 'green' }}>
                          ✅ {responseData.status}
                        </p>
                      )}

                      {responseData.startedCids && responseData.startedCids.length > 0 && (
                        <p style={{ fontSize: '0.95rem', color: 'green' }}>
                          Processing started for CIDs: {responseData.startedCids.join(', ')}
                        </p>
                      )}

                      {responseData.failedCids && responseData.failedCids.length > 0 && (
                        <p style={{ fontSize: '0.95rem', color: 'red' }}>
                          Failed to process CIDs: {responseData.failedCids.join(', ')}
                        </p>
                      )}

                      {(!responseData.startedCids || responseData.startedCids.length === 0) && (
                        <p style={{ fontSize: '1rem', color: 'orange' }}>
                          No downloads initiated. Please check the CIDs and try again.
                        </p>
                      )}
                    </>
                  )}
                </>
              )}
              <br />
            </Grid>
          </Grid>
        </Paper>
      </React.Fragment>
    );
  }
}

HighResGeneration.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withSnackbar(withStyles(styles, { withTheme: true })(HighResGeneration));